module.exports = __webpack_public_path__ + "img/logo-or-menachem-ch.77ca5772.png";